__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-consumer-travel-root'].baseUrl;
import { CARD_PRODUCT, configureProductDucks } from 'axp-product-ducks';
import { configureIguazu } from 'iguazu';
import debounce from 'lodash/debounce';
import fastDeepEqual from 'fast-deep-equal';
import { configureIguazuREST } from 'iguazu-rest';
import ModuleContainer from './components/TravelRoot';
import { getMembersProducts } from './selectors/productsSelectors';
import createTimeoutFetch from './iguazu-rest/createTimeoutFetch';
import { getIguazuResourcesSelector } from './selectors/getModuleStateSelectors';
import resources from './iguazu-rest/resources';
configureProductDucks({
  getToState: getMembersProducts,
  defaultTypes: [CARD_PRODUCT],
  filterTypes: [CARD_PRODUCT],
  orderTypes: [CARD_PRODUCT]
});

/* istanbul ignore next */
configureIguazu({
  stateChangeLimiter: onStateChange => debounce(onStateChange, 100),
  stateChangeComparator: fastDeepEqual
});
configureIguazuREST({
  baseFetch: createTimeoutFetch(60000),
  getToState: getIguazuResourcesSelector,
  resources,
  defaultOpts: {
    timeout: 60000 // in ms
  }
});

/* istanbul ignore next */
if (!global.BROWSER) {
  // To prevent server side configuration from being exposed,
  // make sure to isolate your configuration since it may be
  // sensitive and should be guarded with `!global.BROWSER`

  // eslint-disable-next-line global-require -- Enable
  ModuleContainer.appConfig = require('./config/appConfig').default;
}
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/fetchye-amex': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.13.0',
      module: require('@americanexpress/fetchye-amex')
    },
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.5',
      module: require('@americanexpress/data-manager-utils')
    },
    '@americanexpress/one-app-module-wrapper': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.6.2',
      module: require('@americanexpress/one-app-module-wrapper')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.8.1',
      module: require('@americanexpress/one-experiments')
    },
    '@americanexpress/react-seo': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.4.0',
      module: require('@americanexpress/react-seo')
    },
    '@americanexpress/conditional-features': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.5.0',
      module: require('@americanexpress/conditional-features')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.8',
      module: require('@americanexpress/reactlytics')
    },
    '@americanexpress/travel-selectors': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '5.0.0',
      module: require('@americanexpress/travel-selectors')
    },
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.20',
      module: require('axp-product-ducks')
    },
    'clsx': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.1',
      module: require('clsx')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.8.2',
      module: require('iguazu-holocron')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'react-content-loader': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.2.1',
      module: require('react-content-loader')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.8.9',
      module: require('react-intl')
    },
    'yup': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.32.11',
      module: require('yup')
    },
    'xss': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.0.15',
      module: require('xss')
    },
    'fetchye-one-app': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.0',
      module: require('fetchye-one-app')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-consumer-travel-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-consumer-travel-root';
}